import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '../../buttons/button/button.component';

@Component({
  selector: 'app-root-badge',
  templateUrl: './root-badge.component.html',
  imports: [ButtonComponent],
})
export class RootBadgeComponent {
  @Input() buttonLabel: string;
  @Output() stop = new EventEmitter<void>();
}
